import React, { useState } from 'react';

import styles from './Search.module.scss';

interface IProps {
  placeholder?: string;
  onSearch?: (keyword: string) => void;
}

function Search(props: IProps) {
  const { placeholder = '请输入关键词', onSearch } = props;
  const [keyword, setKeyword] = useState('');

  const handleClick = () => {
    onSearch?.(keyword);
  };

  const handleKeywordChange = (e: React.FormEvent<HTMLInputElement>) => {
    setKeyword(e.currentTarget.value);
  };

  return (
    <div className={styles.wrapper}>
      <input
        className={styles.input}
        type="text"
        value={keyword}
        placeholder={placeholder}
        onChange={handleKeywordChange}
      />
      <button aria-label="search" className={styles.button} onClick={handleClick} />
    </div>
  );
}

export default Search;
